module.exports = __webpack_public_path__ + "img/DigitFrame.7b877cbf.png";